import { useState } from 'react'
import { Alert, Button, List, ListItem, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material'
import { useGetLojaAtualQuery } from '@/api'
import { ativarElgin, ehTefAndroid } from '@/lib/tef/elgin'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'

export function AtivacaoTefTotem(): JSX.Element | null {
  const { data: loja } = useGetLojaAtualQuery()
  const [ativando, setAtivando] = useState(false)
  const [resultado, setResultado] = useState<{ ok: boolean; texto: string } | null>(null)

  const cnpj = loja?.cnpjEmpresa ?? null

  if (!ehTefAndroid()) return null

  async function ativar(): Promise<void> {
    setAtivando(true)
    setResultado(null)

    try {
      await ativarElgin(cnpj)
      setResultado({ ok: true, texto: 'Maquininha ativada. Este totem já pode cobrar.' })
    } catch (e) {
      setResultado({
        ok: false,
        texto: `Não deu certo: ${e instanceof Error ? e.message : 'a maquininha não respondeu'}. Confira se ela está ligada e tente de novo.`,
      })
    } finally {
      setAtivando(false)
    }
  }

  return (
    <Stack spacing={1} sx={{pt: 2}}>
      <Stack spacing={1} direction={'row'} sx={{ alignItems: 'center' }}>
        <List sx={{ width: '100%', p: 0 }}>
          <ListItem sx={{ pl: 1, py: 0 }}>
            <ListItemIcon sx={{ minWidth: '48px' }}>
              <AttachMoneyIcon sx={{ fontSize: '30px' }} />
            </ListItemIcon>

            <ListItemText
              primary="Ativar maquininha de cartão"
              secondary="Ative a maquininha para que o totem possa processar pagamentos."
              slotProps={{ primary: { sx: { fontWeight: 'bold' } } }}
            />
          </ListItem>
        </List>
      </Stack>

      <Button
        fullWidth
        variant="outlined"
        disabled={ativando || !cnpj}
        sx={{ textTransform: 'none' }}
        onClick={() => void ativar()}
      >
        {ativando ? 'Ativando a maquininha…' : 'Ativar a maquininha deste totem'}
      </Button>

      {!cnpj && (
        <Typography variant="body2" color="text.secondary">
          O CNPJ da loja não veio do Sischef. Sem ele a maquininha não pode ser ativada.
        </Typography>
      )}

      {cnpj && !resultado && !ativando && (
        <Typography variant="caption" color="text.secondary">
          Faça isto uma vez, na instalação. A tela da maquininha vai abrir por alguns
          segundos e voltar sozinha.
        </Typography>
      )}

      {resultado && <Alert severity={resultado.ok ? 'success' : 'error'}>{resultado.texto}</Alert>}
    </Stack>
  )
}
